import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ProjectsCTA: React.FC = () => {
  const { t } = useTranslation();

  return (
    // <section className="bg-[#f4f6f8] py-14 md:py-16">
      <div className="text-center mt-14 pb-14 md:pb-16">
        <p className="text-[#64748B] text-sm">
          {t('projectsSection.cta.description')}
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center bg-teal-500 hover:bg-teal-400 text-white font-semibold px-8 py-3.5 transition-all text-sm mt-4 hover:shadow-lg hover:shadow-teal-500/20"
        >
          {t('projectsSection.cta.button')}
        </Link>
      </div>
    // </section>
  );
};

export default ProjectsCTA;
